import { render, staticRenderFns } from "./CollapseKnowledgeItem.vue?vue&type=template&id=473d38ab&scoped=true"
import script from "./CollapseKnowledgeItem.vue?vue&type=script&lang=js"
export * from "./CollapseKnowledgeItem.vue?vue&type=script&lang=js"
import style0 from "./CollapseKnowledgeItem.vue?vue&type=style&index=0&id=473d38ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473d38ab",
  null
  
)

export default component.exports